import { Observable, throwError } from "rxjs";
import { environment } from "@env/environment";
import { Client } from "./master-visualizar-cliente.model";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
const BASE_PATH = environment.basePath;

@Injectable({
  providedIn: "root"
})
export class MasterVisualizarClienteService {
  constructor(private httpClient: HttpClient) {}

  getClientByClientId(institutionId?: any): Observable<Client> {
    if (institutionId === null || institutionId === undefined) {
      return throwError(
        "Required parameter institutionId was null or undefined."
      );
    }

    return this.httpClient.post<Client>(`${BASE_PATH}/bff/clients/view`, institutionId);
  }
}
